module.exports = __webpack_public_path__ + "static/media/testfile_ssuniversalrefinement.70b5c27c.zip";